import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "form-group text-start",
  id: "password_input"
}
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = {
  key: 0,
  class: "form-label text-muted"
}
const _hoisted_4 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_5 = { class: "input-group input-group-merge" }
const _hoisted_6 = ["placeholder", "type"]
const _hoisted_7 = { class: "invalid-feedback" }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordInput',
  props: {
    model: { default: () => ({}) },
    label: { default: "Password" },
    placeholder: { default: "Enter your password" },
    errorMsg: { default: "Por favor, preencha este campo corretamente" },
    required: { type: Boolean, default: false }
  },
  setup(__props: any) {



const passwordFieldType = ref("password");

const togglePassword = () => {
  passwordFieldType.value =
    passwordFieldType.value == "password" ? "text" : "password";
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.label)
        ? (_openBlock(), _createElementBlock("label", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
            (_ctx.required)
              ? (_openBlock(), _createElementBlock("i", _hoisted_4, "*"))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "labelContentEnd")
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.$model) = $event)),
        maxlength: 30,
        class: _normalizeClass([{ 'is-invalid': _ctx.model.$error }, "form-control border-right-0"]),
        placeholder: _ctx.placeholder,
        type: passwordFieldType.value
      }, null, 10, _hoisted_6), [
        [_vModelDynamic, _ctx.model.$model]
      ]),
      _createElementVNode("span", {
        class: _normalizeClass(["input-group-text cursor-pointer", { 'border-danger': _ctx.model.$error }])
      }, [
        _createElementVNode("i", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (togglePassword())),
          class: _normalizeClass(["fas text-muted", {
        'fa-eye': passwordFieldType.value == 'text',
        'fa-eye-slash': passwordFieldType.value == 'password',
      }])
        }, null, 2)
      ], 2),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("small", null, _toDisplayString(_ctx.errorMsg), 1)
      ])
    ])
  ]))
}
}

})